/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationPaymentCurrentPlanResponseData,
  GetOrganizationPaymentCurrentPlanResponseDataFromJSON,
  GetOrganizationPaymentCurrentPlanResponseDataFromJSONTyped,
  GetOrganizationPaymentCurrentPlanResponseDataToJSON
} from './GetOrganizationPaymentCurrentPlanResponseData'

/**
 *
 * @export
 * @interface GetOrganizationPaymentCurrentPlanResponse
 */
export interface GetOrganizationPaymentCurrentPlanResponse {
  /**
   *
   * @type {number}
   * @memberof GetOrganizationPaymentCurrentPlanResponse
   */
  status: number
  /**
   *
   * @type {GetOrganizationPaymentCurrentPlanResponseData}
   * @memberof GetOrganizationPaymentCurrentPlanResponse
   */
  data: GetOrganizationPaymentCurrentPlanResponseData
}

export function GetOrganizationPaymentCurrentPlanResponseFromJSON(
  json: any
): GetOrganizationPaymentCurrentPlanResponse {
  return GetOrganizationPaymentCurrentPlanResponseFromJSONTyped(json, false)
}

export function GetOrganizationPaymentCurrentPlanResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrganizationPaymentCurrentPlanResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOrganizationPaymentCurrentPlanResponseDataFromJSON(json['data'])
  }
}

export function GetOrganizationPaymentCurrentPlanResponseToJSON(
  value?: GetOrganizationPaymentCurrentPlanResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationPaymentCurrentPlanResponseDataToJSON(value.data)
  }
}
